































































import { Component, Vue } from "vue-property-decorator";
import { BookingWizardModule } from "@/store/modules/bookingWizard";
import { CompanyDetailsModule } from "@/store/modules/companyDetails";
import BookingDto from "@/models/Bookings/BookingDto";
import PageNames from "@/router/PageNames";
import GiganautVue from "@/components/Shared/GiganautVue";

@Component({
  name: "CompanyBookingsList",
  components: {},
})
export default class extends GiganautVue {
  async created() {
    await CompanyDetailsModule.getBookings();
  }

  navigateToBooking(booking: BookingDto) {
    this.$router.push({
      name: PageNames.AgencyBookingDetails,
      params: { bookingid: booking.id },
    });
  }

  get loading() {
    return CompanyDetailsModule.loadingBookings;
  }

  private search = "";

  get bookings() {
    return CompanyDetailsModule.bookings;
  }

  private headers = [
    // { text: '', value: 'avatar' },
    // { text: 'Registered Name', value: 'registeredName' },
    // { text: 'Brand Name', value: 'brandName' },
    // { text: 'Phone Number', value: 'phoneNumber' },
    // { text: 'Website', value: 'website' },
    { text: ''},
    { text: "Booking Location" },
    { text: "Booking Start Date" },
  ];

  async navigateToBookingWizard() {
    this.$router.push({
      name: PageNames.AgencyBookingWizard,
      params: { companyid: this.$route.params.companyid },
    });
  }
}
